import { useQuery } from '@tanstack/react-query';
import { clientDetailApi, type MobileDetailResponse } from '@/api/client-detail';

export function useClientDetail(clientId: number | undefined, officeId?: string) {
  return useQuery<MobileDetailResponse>({
    queryKey: ['client-detail', clientId, officeId],
    queryFn: () => clientDetailApi.getMobileDetail(clientId!, officeId),
    enabled: !!clientId,
    staleTime: 30_000, // 30 seconds
  });
}
